<div class="recipe-settings-section1 w800">
    <h1 class="recipe-settings-section1-title">
        Statistical test recipe settings
    </h1>

    <div class="recipe-settings-section2">
        Dummy section
    </div>
</div>
